import { Component } from '@angular/core';

@Component({
  selector: 'app-footer-app',
  standalone: true,
  imports: [],
  templateUrl: './footer-app.component.html',
  styleUrl: './footer-app.component.scss'
})
export class FooterAppComponent {

}
